var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPrefIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75C7 0.75 11.8055 3.67557 11.8055 8.91936C11.7384 10.1289 11.1954 11.2627 10.2949 12.0731C9.39449 12.8835 8.20991 13.3046 7 13.2443V0.75Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75C7 0.75 2.19449 3.67557 2.19449 8.91936C2.26156 10.1289 2.80464 11.2627 3.70508 12.0731C4.60551 12.8835 5.79009 13.3046 7 13.2443V0.75Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPrefIcon);
export default __webpack_public_path__ + "static/media/project-pref-icon.6afa5e8a84de0a5a8059e1eeb86ef661.svg";
export { ForwardRef as ReactComponent };